import React from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { Badge } from '@/components/ui/badge';
import { RetentionTaxonomyChart } from './retention-taxonomy-chart';

const LEVEL_CONFIG = {
  1: { label: 'Nível 1', variant: 'danger', color: '#EF4444' },
  2: { label: 'Nível 2', variant: 'third', color: '#F97316' },
  3: { label: 'Nível 3', variant: 'warning', color: '#EAB308' },
  4: { label: 'Nível 4', variant: 'success-light', color: '#22C55E' },
  5: { label: 'Nível 5', variant: 'success', color: '#10B981' }
};

export function RetentionTaxonomyCard({ taxonomy, expanded, onToggle }) {
  const {
    name,
    level,
    streak_days,
    current_retention,
    trend,
    cards_reviewed,
    total_cards,
    next_review_days,
    history
  } = taxonomy;

  const levelConfig = LEVEL_CONFIG[level] || LEVEL_CONFIG[1];
  const trendIsPositive = trend >= 0;

  return (
    <div className={`taxonomy-card ${expanded ? 'taxonomy-card--expanded' : ''}`}>
      <button
        className="taxonomy-card__header"
        onClick={onToggle}
        type="button"
        aria-expanded={expanded}
      >
        <div className="taxonomy-card__left">
          {streak_days > 0 && (
            <span className={`taxonomy-card__streak ${streak_days >= 7 ? 'taxonomy-card__streak--fire' : ''}`}>
              🔥{streak_days}
            </span>
          )}
          <span className="taxonomy-card__name">{name}</span>
        </div>
        <div className="taxonomy-card__right">
          <Badge variant={levelConfig.variant} size="xs">
            {levelConfig.label}
          </Badge>
          {expanded ? <FiChevronUp /> : <FiChevronDown />}
        </div>
      </button>

      <div className="taxonomy-card__progress-row">
        <div className="taxonomy-card__progress-bar">
          <div
            className="taxonomy-card__progress-fill"
            style={{
              width: `${current_retention}%`,
              backgroundColor: levelConfig.color
            }}
          />
        </div>
        <span className="taxonomy-card__retention">{current_retention.toFixed(0)}%</span>
        <span className={`taxonomy-card__trend ${trendIsPositive ? 'taxonomy-card__trend--up' : 'taxonomy-card__trend--down'}`}>
          {trendIsPositive ? '↑' : '↓'} {Math.abs(trend).toFixed(0)}%
        </span>
      </div>

      {expanded && (
        <div className="taxonomy-card__details">
          <RetentionTaxonomyChart history={history} color={levelConfig.color} />

          <div className="taxonomy-card__stats">
            <div className="taxonomy-card__stat">
              <span className="taxonomy-card__stat-icon">📚</span>
              <span className="taxonomy-card__stat-value">{cards_reviewed}</span>
              <span className="taxonomy-card__stat-label">revisados</span>
            </div>
            {next_review_days !== null && (
              <div className="taxonomy-card__stat">
                <span className="taxonomy-card__stat-icon">⏱️</span>
                <span className="taxonomy-card__stat-value">~{next_review_days} {next_review_days === 1 ? 'dia' : 'dias'}</span>
                <span className="taxonomy-card__stat-label">próx. rev.</span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
